import React from 'react';
import { useNavigate } from 'react-router-dom';
import SelectForm from '../SelectForm';
import InputForm from '../InputForm';
import PermisoSwitch from './PermisoSwitch';
import InputPhone from '../InputPhone';
import SelectMultiForm from '../SelectMultiForm';


const CompanyLayer = ({datos, handleChange, handleSave, tipo_usuario, sucursales, sucursalesUsuario, secciones, handlePermisos, handleSucursal, onChangeValidity, onChangePhone, onChangeCountry,error}) => {
    const navigate = useNavigate();
    const goBack = () => navigate(-1);

    const handleReenviarCredenciales = () => {
        fetch("/p_usuario_credenciales",{
            method: "POST",
            headers:{
                "Content-Type": "application/json",
            },
            body: JSON.stringify({id: datos.id})
        })
        .then((res) => res.json())
        .then((data) => {
            console.log(data);
            if(data.status === 1){
                // Success
                
            }
        });
    }
    
    return (
        <div className="card h-100 p-0 radius-12 overflow-hidden">
            <div className="card-body p-40">
                <div className="row">
                    <InputForm
                        name="nombre"
                        label="Nombre"
                        datos={datos}
                        change={handleChange}
                        error={error}
                        required/>
                    <InputForm
                        col="col-sm-6"
                        name="apellido_paterno"
                        label="Apellido Paterno"
                        datos={datos}
                        change={handleChange}
                        error={error}
                        required/>
                    <InputForm
                        col="col-sm-6"
                        name="apellido_materno"
                        label="Apellido Materno"
                        datos={datos}
                        change={handleChange}
                        error={error}
                        required/>
                    <InputForm
                        col="col-sm-6"
                        type="email"
                        name="correo"
                        label="Correo"
                        datos={datos}
                        change={handleChange}
                        error={error}   
                        required/>
                    <InputPhone
                        datos={datos}
                        onChangePhone={onChangePhone}
                        onChangeCountry={onChangeCountry}
                        onChangeValidity={onChangeValidity}
                        error={error}
                        name="telefono"
                        required
                    />
                    <SelectMultiForm
                        col="col-sm-12"
                        datos={sucursales} 
                        change={handleSucursal}
                        values={sucursalesUsuario}
                        placeholder="Seleccione una o varias sucursales"
                        error={error}
                        name="sucursales"
                    />
                    <SelectForm
                        col="col-sm-12"
                        name='tipo'
                        label='Tipo Usuario'
                        datos={datos}
                        change={handleChange}
                        options={tipo_usuario}
                    />
                    {
                        datos.id > 0 && (
                            <div className="col-12">
                            <button
                                onClick={handleReenviarCredenciales}
                                className="btn btn-primary col-2 border border-primary-600 text-md px-24 py-12 radius-8 mb-3"
                            >
                                Reenviar credenciales
                            </button>
                            </div>
                        )
                    }
                    { secciones.map((item, index) => <PermisoSwitch key={index} item={item} index={index} handlePermisos={handlePermisos} tipo={datos.tipo == "1"}/>)}
                    <div className="d-flex align-items-center justify-content-between gap-3 mt-24">
                        <button
                            onClick={goBack}
                            type="reset"
                            className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                        >
                            Cancelar
                        </button>
                        <button
                            onClick={handleSave}
                            className="btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                        >
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default CompanyLayer;